<template>
  <div>
    <answer-render ref="answer" :config="config[questionIndex]">
      <div slot="head">
        <answer-group-table
          :config="config"
          optionKey="optionName"
          optionValueKey="id"
          :answerValidate="answerValidate"
          :questionIndex="questionIndex"
        ></answer-group-table>
      </div>
    </answer-render>
  </div>
</template>

<script>
import answerValidate from './answerValidate'
export default {
  name: 'RadioBoxGroupAnswerPc',
  props: ['config', 'questionIndex'],
  data () {
    return {
      answerValidate
    }
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/RadioBoxGroup/RadioBoxGroupAnswerPc.vue